import { Typography } from "@mui/material";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import BaseDialog from "../BaseDialog";
import { EMERGENCY_TYPE } from "../../pages/applicant/ResponsibleAdults/constants";
import { useTranslate } from "../../hooks/useTranslate";

const AddContactTypeModal = (props) => {
    const { addDialogOpen, setAddDialogOpen, onAddContact } = props;

    const { t } = useTranslate();

    return (
        <BaseDialog
            open={addDialogOpen}
            onClose={() => setAddDialogOpen(false)}
            withCloseButton
            isWide
        >
            <div className="p-4">
                <div
                    className="flex align-center justify-between gap-4 pointer p-4 mb-4 hover-bg-greyish"
                    onClick={onAddContact()}
                    role="button"
                    tabIndex={-1}
                >
                    <div>
                        <Typography
                            variant="h2"
                            className="text-primary"
                            component="div"
                        >
                            {t("responsibleAdults.addNewAdult")}
                        </Typography>
                        <Typography
                            variant="body1"
                            component="div"
                        >
                            {t("responsibleAdults.addNewAdultSubtitle")}
                        </Typography>
                    </div>
                    <span className="icon-border-rounded">
                        <ArrowForwardIosOutlinedIcon />
                    </span>
                </div>
                <div
                    className="flex align-center justify-between gap-4 pointer p-4 hover-bg-greyish"
                    onClick={onAddContact(EMERGENCY_TYPE)}
                    role="button"
                    tabIndex={-1}
                >
                    <div>
                        <Typography variant="h2" className="text-primary" component="div">
                            {t("responsibleAdults.addEmergencyAdult")}
                        </Typography>
                        <Typography variant="body1" component="div">
                            {t("responsibleAdults.addEmergencyAdultSubtitle")}
                        </Typography>
                    </div>
                    <span className="icon-border-rounded">
                        <ArrowForwardIosOutlinedIcon />
                    </span>
                </div>
            </div>
        </BaseDialog>
    );
};

export default AddContactTypeModal;
